import * as R from 'ramda';

import type { Filters } from '../FiltersContext';
import type { IEvent } from '../../';

const hasSelectedCities = (filters) => filters.selectedCities?.length > 0;
const hasSelectedCountries = (filters) => filters.selectedCountries?.length > 0;
const hasSelectedStates = (filters) => filters.selectedStates?.length > 0;

export const canFilterByCountry = hasSelectedCountries;
export const canFilterByState = R.allPass([hasSelectedStates, hasSelectedCountries]);
export const canFilterByCity = R.allPass([hasSelectedCities, hasSelectedStates, hasSelectedCountries]);

export const filterByCountry = (filters: Filters) => (event: IEvent) =>
	canFilterByCountry(filters) ? filters.selectedCountries.includes(event.country) : true;

export const filterByState = (filters: Filters) => (event: IEvent) =>
	canFilterByState(filters) ? filters.selectedStates.includes(event.state) : true;

export const filterByCity = (filters: Filters) => (event: IEvent) =>
	canFilterByCity(filters) ? filters.selectedCities.includes(event.city) : true;
